module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/229-turkmenistan-d19e8ac18fb8d3f325c9f8242a30b8cf.svg";